module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAzUlEQVQ4jeWUQQ7CIBBFP8a9HqXuOYwnIHoC7Qk0XKAehr09Sj0Bhjo07USgAW1ifBv6S/mZ+aGDn0OECrZK3gFUAFqhzW7unmcVSaJi69y9nqFiq+QewAXANjP2DsBRaHMDq7gpMAWdbbyIRVHE14zX/IXQJnhTYlglbdQYr49cXgeSV1qDWmjTJSsmTqODjk1Cn7nBchkTNYAHPfvWU3rC4hX/YcZvjele8vZSOm7M/6Bcxhn3466QwWMyF6ySbnBnz2OhTfuJbsMAeAKzlDjjzAl5KAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_form_calendar.png
// module id = 932
// module chunks = 0